import { render } from "./issue_drug_input.vue?vue&type=template&id=3288d82e&scoped=true"
import script from "./issue_drug_input.vue?vue&type=script&lang=js"
export * from "./issue_drug_input.vue?vue&type=script&lang=js"

import "./issue_drug_input.vue?vue&type=style&index=0&id=3288d82e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3288d82e"]])

export default __exports__